import axios from "axios";
import { ActionType } from "@pl-flight-recorder/common/models/enum/action-type.enum";
import { CaptureMethodStatus } from "@pl-flight-recorder/common/models/enum/capture-method-status.enum";
import { SurveySchema } from "./MfaFeedbackService";

export { CaptureMethodStatus };

export interface CaptureMethod {
  createdAt: string;
  updatedAt: string;
  captureId: number;
  projectId: string;
  status: string; //CaptureMethodStatus;
  actionType: string;
  screenRecordingConf: Record<string, unknown>;
  surveyId: string;
  surveyVersion: string;
  surveyAccessKey: string;
  surveyMetadata: {
    tempSurveySchema: string;
  };
  createdUserId: string;
  surveySchema: string;
}

export interface CaptureMethodInput {
  projectId: string;
  actionType: ActionType;
  screenRecordingConf: Record<string, unknown>;
  surveySchema?: SurveySchema;
  status: CaptureMethodStatus | string;
}

export interface CaptureMethodSurveyInput {
  projectId: string;
  actionType: ActionType;
  screenRecordingConf: Record<string, unknown>;
  surveyId: string;
  status: string;
}

class MfaCaptureMethodService {
  private static instance: MfaCaptureMethodService;
  private baseUrl = `${process.env.REACT_APP_API_BASE_URL}/flight-recorder`;

  private constructor() {}

  static getInstance(): MfaCaptureMethodService {
    if (!MfaCaptureMethodService.instance) {
      MfaCaptureMethodService.instance = new MfaCaptureMethodService();
    }
    return MfaCaptureMethodService.instance;
  }

  async getCapturesByProjectId(
    projectId: string,
    // token: string,
    limit: number = 10,
  ): Promise<{
    data: CaptureMethod[];
    limit: number;
    paginationNextToken?: string;
  }> {
    const response = await axios.get<{
      data: CaptureMethod[];
      limit: number;
      paginationNextToken?: string;
    }>(`${this.baseUrl}/capture-method/project/${projectId}`, {
      params: { limit },
      headers: {
        // Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  async getCaptureMethodsByAppKey(
    appKey: string,
    // token: string,
  ): Promise<CaptureMethod[]> {
    const response = await axios.get<CaptureMethod[]>(
      `${this.baseUrl}/capture-method/app-key/${appKey}`,
      {
        headers: {
          // Authorization: `Bearer ${token}`
        },
      },
    );
    return response.data;
  }

  async createCapture(
    data: CaptureMethodInput,
    token: string,
    workspaceId: string,
  ) {
    console.log("createCapture", data, token, workspaceId);
    try {
      const response = await axios.post(
        `${this.baseUrl}/capture-method`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "workspace-id": workspaceId,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Failed to create capture method:", error);
      throw error;
    }
  }

  async duplicateCapture(
    captureId: number,
    token: string,
    workspaceId: string,
  ): Promise<CaptureMethod> {
    console.log("duplicateCapture", captureId, token, workspaceId);
    try {
      const response = await axios.post<CaptureMethod>(
        `${this.baseUrl}/capture-method/${captureId}/duplicate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "workspace-id": workspaceId,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Failed to duplicate capture method:", error);
      throw error;
    }
  }

  async updateCaptureStatus(
    captureId: number,
    status: string, //CaptureMethodStatus,
    userId: string,
    token: string,
    workspaceId: string,
  ): Promise<CaptureMethod> {
    console.log(
      "updateCaptureStatus",
      captureId,
      status,
      userId,
      token,
      workspaceId,
    );
    try {
      const response = await axios.put<CaptureMethod>(
        `${this.baseUrl}/capture-method/${captureId}/status`,
        { status },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            userid: userId,
            captureId: captureId.toString(),
            Authorization: `Bearer ${token}`,
            // "workspace-id": workspaceId,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Failed to update capture status:", error);
      throw error;
    }
  }

  async getCaptureMethod(captureId: number): Promise<CaptureMethod> {
    // Don't pass token here, it's not needed
    try {
      const response = await axios.get<CaptureMethod>(
        `${this.baseUrl}/capture-method/${captureId}`,
        {},
      );
      return response.data;
    } catch (error) {
      console.error("Failed to get capture method:", error);
      throw error;
    }
  }

  async updateFeedbackForm(
    captureId: string,
    data: CaptureMethodSurveyInput,
    token: string,
    workspaceId: string,
  ): Promise<CaptureMethod> {
    try {
      const response = await axios.put<CaptureMethod>(
        `${this.baseUrl}/capture-method/${captureId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "workspace-id": workspaceId,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Failed to update feedback form:", error);
      throw error;
    }
  }
}

export default MfaCaptureMethodService;
